import { Grid2, Paper } from '@mui/material'
import React from 'react'

const SingleColumnLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <Grid2
      size={{ xs: 12 }}
      sx={{
        flex: 1,
        minHeight: 0,
        minWidth: 0,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Paper
        elevation={4}
        sx={{
          flex: 1,
          minHeight: 0,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'auto',
          mb: { xs: 2, lg: 0 },
          px: 2,
          pb: 2,
          pt: { xs: 0, lg: 2 },
          backgroundColor: 'white',
          borderRadius: { xs: 1, lg: 0 },
        }}
        className="hide-scrollbar"
      >
        {children}
      </Paper>
    </Grid2>
  )
}

export default SingleColumnLayout
